const appNavigation = [
  {
    path: "/",
    label: "Deployment"
  },
  {
    path: "/documentation",
    label: "Documentation"
  },
  {
    path: "/logout",
    label: "Logout"
  }
];

export default appNavigation;
